<template>
  <div class="tooltip p-absolute">
    <div class="tooltip__wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TooltipApp'
})
</script>

<style scoped lang="scss">
  .tooltip {
    right: 0;
    top: 120%;
    z-index: 1;

    padding: 12px 0 0;

    opacity: 0;
    visibility: hidden;
    transition: opacity .4s ease-in-out, top .4s ease-in-out, visibility 0s .4s;

    .is-dark-theme &:before,
    .is-dark-theme &__wrapper {
      background-color: rgb(var(--gray8));
    }

    &:before,
    &__wrapper {
      border-radius: 3px;
      background-color: rgb(var(--white));
    }

    &:before {
      --arrowSize: 12px;

      content: '';
      right: calc((40px - 12px) / 2);
      top: calc(var(--arrowSize) / 2);
      position: absolute;
      transform: rotate(-45deg);
      border-radius: 3px;
      z-index: -1;

      width: var(--arrowSize);
      height: var(--arrowSize);
    }

    .has-tooltip:hover & {
      top: 100%;
      opacity: 1;
      visibility: visible;
      transition: opacity .4s ease-in-out, top .4s ease-in-out, visibility 0s;
    }

    &__wrapper {
      padding: 15px;
      max-width: 320px;
      background-color: rgb(var(--white));
      box-shadow: 0 1px 6px -6px rgb(var(--black));
    }
  }
</style>
